import * as idbKeyVal from 'idb-keyval';
/**
 * The keyValueStore object is an instance of the idb-keyval library.
 * Idb-keyval is a super-simple-small promise-based keyval store implemented with IndexedDB,
 * which is a low-level API for client-side storage of significant amounts of structured data,
 * including files/blobs. This API uses indexes to enable high-performance searches of this data..
 *
 * @example
 * // Set a value
 * keyValueStore.set('hello', 'world');
 *
 * // Get a value
 * keyValueStore.get('hello').then(val => console.log(val)); // 'world'
 *
 * // Check if a key exists
 * keyValueStore.has('hello').then(exists => console.log(exists)); // true
 *
 * // Delete a key
 * keyValueStore.del('hello');
 *
 * @see {@link https://www.npmjs.com/package/idb-keyval|idb-keyval}
 */
export const keyValueStore = idbKeyVal;
//# sourceMappingURL=key-value-store.js.map